import { useQuery } from "@tanstack/react-query";
import galleriesAPI from "../../api/galleries/api";

export function getQueryKey(id: string | number) {
  return ["galleries", id];
}

export function useGetGalleryById(
  id: string | number,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: getQueryKey(id),
    queryFn: () => galleriesAPI.getGalleryById(id),
    enabled: !!id && options?.enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
